import { TransitionType, makeTransition } from '../../../../utils/styles/makeTransition';
import { DataTestId } from '../../../layout/DataTestIdWrapper';
import { PostButton as PostButtonBase } from '../../PostButton/PostButton';
import { PRODUCT_BUTTON_TRANSITION_TIMING } from '../AnimateFooter/constants';
import { ButtonBox } from './styles';
import { PostButtonProps } from './types';

export const PostButton = (props: PostButtonProps) => {
    const { clickOut, isExpanded, isProductExpanded, products, transitionTiming } = props;

    if (products.items.length) {
        return (
            <ButtonBox
                isExpanded={isExpanded}
                isProductExpanded={isProductExpanded}
                transition={makeTransition({
                    ms: transitionTiming,
                    styles: ['width', 'height'],
                    type:
                        transitionTiming === PRODUCT_BUTTON_TRANSITION_TIMING
                            ? TransitionType.EASE_OUT
                            : TransitionType.LINEAR,
                })}
            >
                <PostButtonBase {...props} />
            </ButtonBox>
        );
    }

    if (clickOut) {
        return (
            <ButtonBox
                isExpanded={isExpanded}
                dataTestId={DataTestId.CLICK_OUT}
                transition={makeTransition({
                    ms: transitionTiming,
                    styles: ['width', 'height'],
                })}
            >
                <PostButtonBase {...props} />
            </ButtonBox>
        );
    }

    return null;
};
